export const applyOutcomeLogic = (
  jobs: any[],
  selectedInstitute: any,
  outcomeCategory: string,
  userInstitutes: any[] = []
) => {

  if (!selectedInstitute?.passOutYear || !outcomeCategory) {
    return {
      updatedJobs: jobs,
      updatedSelectedInstitute: selectedInstitute,
      updatedUserInstitutes: userInstitutes
    };
  }

  const numericPassOutYear = Number(selectedInstitute.passOutYear);
  const teachingJob = jobs.find(
    (job) =>
      job?.jobCategory === outcomeCategory &&
      job?.isCurrent === true &&
      job?.recordTypeCode === 'JOINED'
  );

  console.log("selectedInstitute.passOutYear",selectedInstitute.passOutYear)
  console.log("teachingJob?.startDate",teachingJob?.startDate)
    if (!teachingJob?.startDate) {
      return {
        updatedJobs: jobs,
        updatedSelectedInstitute: selectedInstitute,
        updatedUserInstitutes: userInstitutes
      };
    }

    // const yearDiff = new Date(teachingJob.startDate).getFullYear() - numericPassOutYear;
     const yearDiff = Math.abs(
      (new Date(teachingJob?.startDate).getFullYear() || 0) -
      (numericPassOutYear || 0)
    );
    console.log("yearDiff",yearDiff)
    console.log("updatedJobs",jobs)
    console.log("teachingJob",teachingJob)
    
    const updatedJobs = jobs.map((job) => {
    if (
      job?.jobCategory === outcomeCategory &&
      job?.isCurrent === true &&
      job?.recordTypeCode === 'JOINED'
    ) {
      return {
        ...job,
        isOutcome: yearDiff < 2 ? 1 : 0
      };
    }
    return job;
  });

  const updatedUserInstitutes = userInstitutes.map((inst) => {
    if (inst.instituteId === selectedInstitute.instituteId) {
      return {
        ...inst,
        postProgramCompletionStatusCode:
          yearDiff < 2
            ? (outcomeCategory === 'DEFENCE' ? 'IN_DEFENCE' : outcomeCategory)
            : inst.postProgramCompletionStatusCode
      };
    }
    return inst;
  });

  const updatedSelectedInstitute = {
    ...selectedInstitute,
    postProgramCompletionStatusCode:
      yearDiff < 2
        ? (outcomeCategory === 'DEFENCE' ? 'IN_DEFENCE' : outcomeCategory)
        : selectedInstitute.postProgramCompletionStatusCode
  };

  return {
    updatedJobs,
    updatedSelectedInstitute,
    updatedUserInstitutes
  };
};
